
<button class="btn btn-lg bg-white float-right" (click)="onNewContactClick()"><i class="align-middle fas fa-plus-circle"></i> New Contact </button>
<table class="neu-table table table-striped neu-table w-100" datatable [dtOptions]="dtOptions" data-page="2" ></table>